import React from "react";
import { Box } from "@material-ui/core";

const MapContainer = props => {
    const {height = 400} = props
  return (
          <Box position="relative" height={height} overflow="hidden">
            {props.children}
          </Box>
  );
};

export default MapContainer;